import { render, staticRenderFns } from "./AsideMobile.vue?vue&type=template&id=c23810da&scoped=true"
import script from "./AsideMobile.vue?vue&type=script&lang=js"
export * from "./AsideMobile.vue?vue&type=script&lang=js"
import style0 from "./AsideMobile.vue?vue&type=style&index=0&id=c23810da&prod&lang=less&scoped=true"
import style1 from "./AsideMobile.vue?vue&type=style&index=1&id=c23810da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a384144eff487845a016474d887108a3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23810da",
  null
  
)

export default component.exports